import { render, staticRenderFns } from "./Tour2.vue?vue&type=template&id=21d9bf91"
import script from "./Tour2.vue?vue&type=script&lang=js"
export * from "./Tour2.vue?vue&type=script&lang=js"
import style0 from "./Tour2.vue?vue&type=style&index=0&id=21d9bf91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports